export const MimeTypesArray = [
  'video/mp4; codecs="avc1.42E01E"',
  'audio/mp4; codecs="mp4a.40.2"',
  'video/mp2t; codecs="avc1.42E01E"',
  'video/mp2t; codecs="mp4a.40.2"',
];
